import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
// import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

export default function DraftDeleteModal (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const [deleteUrl, setDeleteUrl] = useState(null)

  useEffect(() => {
    $('button.open-draft-delete-modal').each((i, el) => {
      $(el).on('click', () => {
        setModalOpen(true)
        setDeleteUrl(el.dataset.deleteUrl)
      })
    })
  }, [])

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <h2>下書き削除確認</h2>
        <hr />
        <BootstrapAlert class={'danger'}>
          <>
            下書きを削除すると、これを閲覧可能な他のユーザーからも閲覧できなくなります。<br/>
            削除しますか？
          </>
        </BootstrapAlert>
        <hr />
        <div className="row theme-3">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => { setModalOpen(false); setDeleteUrl(null) }}>
              キャンセル
            </button>
          </div>
          <div className="col-6 text-right">
            <form action={deleteUrl ?? '#'} method="post">
              <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
              <button type='submit' name="delete-submit" className='btn btn-danger' onClick={(e) => { window.onbeforeunload = null }}>
                削除
              </button>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  )
}

DraftDeleteModal.propTypes = {
}

$('.draft-delete-modal').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <DraftDeleteModal {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
